module.exports = __webpack_public_path__ + "media/components/country-flag/static/dz-8c26c6c45a5b5c115674a7425fb3e179.svg";